import { $, $$, on } from '../utils'

class Slideshow {

  constructor(selector) {
    const dom = $(selector)
    this.current = 0
    this.dom = dom
    this.prevBtn = $('[data-prev-btn]', dom)
    this.nextBtn = $('[data-next-btn]', dom)
    this.dotBtns = $$('[data-dot-bar] button', dom)
    this.max = this.dotBtns.length - 1
    this.init()
  }

  init() {
    on(this.prevBtn, 'click', () => this.goPrev())
    on(this.nextBtn, 'click', () => this.goNext())
    this.dotBtns.forEach((dotBtn, i) => {
      on(dotBtn, 'click', () => this.go(i))
    })
  }

  setIndex(i) {
    this.dom.classList.remove(`slideshow--${this.current}`)
    this.dom.classList.add(`slideshow--${i}`)
    this.current = i
  }

  goPrev() {
    if (this.current > 0) {
      this.setIndex(this.current - 1)
    }
    else {
      this.setIndex(this.max)
    }
  }

  goNext() {
    if (this.current < this.max) {
      this.setIndex(this.current + 1)
    }
    else {
      this.setIndex(0)
    }
  }

  go(i) {
    this.setIndex(i)
  }
}

export default Slideshow
